import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { platformApi, downloadApi } from "../../apis/services";
import { errorResponseHandler } from "../../apis/http";

import { FaPinterestP, FaXTwitter, FaFacebookF, FaInstagram } from "react-icons/fa6";
import { FaLinkedinIn, FaTiktok } from "react-icons/fa";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { successNotification } from "../Toast";
import pdfFile from "./pdf.pdf";

const Footer = () => {
  const [data, setData] = useState();

  const fetchData = async () => {
    try {
      const response = await platformApi();
      setData(response?.platforms?.[0]);
    } catch (error) {
      errorResponseHandler(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Email is required"),
  });

  const handleNewsLetterSubmit = async (values, { resetForm }) => {
    try {
      const response = await downloadApi(values);
      if (!response.error) {
        successNotification("Email Added Successfully");

        const link = document.createElement("a");
        link.href = pdfFile;
        link.download = "pdf.pdf";
        link.click();

        resetForm();
      }
    } catch (error) {
      errorResponseHandler(error);
    }
  };

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-4">
                <div className="footer-about">
                  <div className="footer-logo">
                    <img src="/images/logo.png" alt="Logo" />
                  </div>

                  <div className="about-footer-content">
                    <p>{data?.content}</p>
                  </div>

                  <div className="footer-social-links">
                    <span>Follow on: </span>
                    <ul>
                      <li>
                        <a href={data?.pinterest} target="_blank" rel="noreferrer">
                          <FaLinkedinIn />                      </a>
                      </li>
                      <li>
                        <a href={data?.twitter} target="_blank" rel="noreferrer">
                          <FaTiktok />                      </a>
                      </li>
                      <li>
                        <a href={data?.facebook} target="_blank" rel="noreferrer">
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a href={data?.instagram} target="_blank" rel="noreferrer">
                          <FaInstagram />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-2">

                <div className="footer-links">
                  <h3>Useful Links</h3>
                  <ul>
                    <li>
                      <Link to="/how-it-works">How it works</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About IngredientIQ™</Link>
                    </li>
                    <li>
                      <Link to="/app">The App</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Resources</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-4">
                <div className="footer-links">
                  <h3>Download App</h3>
                  <div
                    className="hero-content-body wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div style={{ display: "flex", gap: "15px", justifyContent: "center", marginTop: "20px" }}>
                      <a href="#!">
                        <img src="/images/app-store.png" alt="App Store" style={{ width: "150px", height: "auto" }} />
                      </a>
                      <a href="#!">
                        <img src="/images/google-play.png" alt="Google Play" style={{ width: "150px", height: "auto" }} />
                      </a>
                    </div>

                  </div>

                  <div className="email-capture">
                    <h3 className="mb-3">Get Smart Label Decoder PDF</h3>
                    <Formik
                      initialValues={{ email: "" }}
                      validationSchema={validationSchema}
                      onSubmit={handleNewsLetterSubmit}
                    >
                      {({ isSubmitting }) => (
                        <Form className="flex flex-col gap-2">
                          <Field
                            type="email"
                            name="email"
                            placeholder="Enter your email..."
                            className="border px-3 py-2 rounded-md"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-red-500 text-sm"
                            style={{ color: "red" }}
                          />
                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn-accent"
                          >
                            {isSubmitting ? "Submitting..." : "Download"}
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>

      <div className="footer-copyright">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-5">
              <div className="footer-copyright-text">
                <p>Copyright © 2025 All Rights Reserved.</p>
              </div>
            </div>

            <div className="col-lg-6 col-md-7">
              <div className="footer-privacy-policy">
                <ul>
                  <li>
                    <Link to="/privacy-policy">Privacy policy</Link>
                  </li>
                  <li>
                    <Link to="/terms-condition">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
